import React from 'react'
import styled from 'styled-components'
import CurrencyLogo from '../CurrencyLogo'
import SwapInputSymbol from './SwapInputSymbol'
import { DropDownStyledSVG } from '../DropDown'
import { coinImage } from '../../assets/coins/coins'
import { Token } from '../../logic/token/token'

export const SwapInputCurrency = styled.div`
  display: flex;
  justify-content: start;
  align-self: center;
`

export const SwapInputEmptyCurrency = styled.div`
  align-self: center;
  font-size: 1.75rem;
  padding: 0em;

  /* Mobiles */
  @media (max-width: 640px) {
    font-size: 1.25rem;
  }
`

const _SwapInputCurrencyWrapper = styled.div<{ isValidCurrency: boolean }>`
  display: flex;
  align-items: center;
  justify-items: center;
  box-shadow: ${({ theme }) => theme.tradeCurrencyShadow};
  color: ${({ theme, isValidCurrency }) =>
    isValidCurrency
      ? theme.tradeCurrencyTextColor
      : theme.tradeEmptyCurrencyTextColor};
  background-color: ${({ theme, isValidCurrency }) =>
    isValidCurrency
      ? theme.tradeCurrencyBackgroundColor
      : theme.tradeEmptyCurrencyBackgroundColor};
  cursor: pointer;
  pointer-events: auto;
  border-radius: 1.8rem;
  font-size: 3rem;
  margin: 10px 0px 12px 0px;
  padding: 0 1.4rem;
  height: 40px;

  /* Mobiles */
  @media (max-width: 640px) {
    font-size: 2.25rem;
    margin: 5px 0px 20px 0px;
    height: 35px;
    border-radius: 2rem;
  }

  :hover {
  	opacity: 0.8
  }
`

const DropDownStyledSVGWrapper = styled.div`
  display: flex;
  align-self: center;
  font-size: 3rem;
  padding-left: 5px;
  padding-top: 10px;

  /* Mobiles */
  @media (max-width: 640px) {
    font-size: 2.25rem;
  }
`

interface Props {
  onClick: VoidFunction
  currency: Token | undefined
}

function SwapInputCurrencyWrapper(props: Props) {
  return (
    <_SwapInputCurrencyWrapper
      onClick={props.onClick}
      isValidCurrency={props.currency != undefined}
      data-cy={'currency-selector'}
    >
      {
        // TODO : should not test at least props.currency.symbol
        props.currency && props.currency.symbol ? (
          <SwapInputCurrency>
            <CurrencyLogo src={coinImage(props.currency.symbol)!} />
            <SwapInputSymbol>{props.currency['symbol']}</SwapInputSymbol>
            <DropDownStyledSVGWrapper>
              {' '}
              <DropDownStyledSVG selected={true} />{' '}
            </DropDownStyledSVGWrapper>
          </SwapInputCurrency>
        ) : (
          <SwapInputCurrency>
            <SwapInputEmptyCurrency>
              Choose token
            </SwapInputEmptyCurrency>
            <DropDownStyledSVGWrapper>
              {' '}
              <DropDownStyledSVG selected={false} />{' '}
            </DropDownStyledSVGWrapper>
          </SwapInputCurrency>
        )
      }
    </_SwapInputCurrencyWrapper>
  )
}

export default SwapInputCurrencyWrapper
